import React from 'react';
import styled from 'styled-components';

const FooterContainer = styled.footer`
  background: ${props => props.theme.colors.black};
  color: ${props => props.theme.colors.white};
  padding: ${props => props.theme.spacing.xl} 0;
  margin-top: auto;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 ${props => props.theme.spacing.md};
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: ${props => props.theme.spacing.lg};
`;

const FooterSection = styled.div`
  h3 {
    color: ${props => props.theme.colors.orange};
    margin-bottom: ${props => props.theme.spacing.md};
  }
  
  p, li {
    margin-bottom: ${props => props.theme.spacing.sm};
    opacity: 0.9;
  }
  
  ul {
    list-style: none;
  }
  
  a {
    color: ${props => props.theme.colors.white};
    text-decoration: none;
    transition: color 0.3s ease;
    
    &:hover {
      color: ${props => props.theme.colors.orange};
    }
  }
`;

const FooterBottom = styled.div`
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  margin-top: ${props => props.theme.spacing.lg};
  padding-top: ${props => props.theme.spacing.lg};
  text-align: center;
  opacity: 0.8;
`;

const Footer: React.FC = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <FooterSection>
          <h3>O ZUSik</h3>
          <p>
            Narzędzie edukacyjne do prognozowania wysokości przyszłej emerytury.
            ZUSik ma charakter informacyjny i nie gwarantuje dokładności obliczeń.
          </p>
        </FooterSection>
        
        <FooterSection>
          <h3>Informacje</h3>
          <ul>
            <li>Narzędzie edukacyjne</li>
            <li>Charakter informacyjny</li>
            <li>Nie gwarantuje dokładności</li>
            <li>Warto skonsultować z ekspertem</li>
          </ul>
        </FooterSection>
        
        <FooterSection>
          <h3>Dostępność</h3>
          <p>
            Aplikacja spełnia standardy WCAG 2.0 
            i jest dostępna dla wszystkich użytkowników.
          </p>
        </FooterSection>
        
        <FooterSection>
          <h3>Źródła danych</h3>
          <ul>
            <li>Prognoza wpływów i wydatków FE do 2080</li>
            <li>Dane GUS</li>
            <li>Dane NBP</li>
            <li>Dane Ministerstwa Finansów</li>
          </ul>
        </FooterSection>
      </FooterContent>
      
      <FooterBottom>
        <p>&copy; 2025 ZUSik. Narzędzie edukacyjne.</p>
      </FooterBottom>
    </FooterContainer>
  );
};

export default Footer;
